module.exports = __webpack_public_path__ + "static/media/icon-settings.26e0f8b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Nav/assets/icon-settings.svg
// module id = 1498
// module chunks = 193